import useYearsLastPeriod from "backend/hooks/model/useYearsLastPeriod";
import { ICardElementWithChildren } from "backend/model/model";
import ProgressModal from "design/components/progress/ProgressModal";
import React from "react";
import Report from "reportengine/Report";
import Slide from "reportengine/Slide";
import TextElement from "reportengine/TextElement";
import { createReport, saveBlob } from "reportengine/createReport";
import reportContextToRequest from "./reportContextToRequest";
import KPISlide from "./slides/KPISlide";
import useElement from "backend/hooks/elements/useElement";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { t } from "i18next";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";

const KPIReport = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
    filetype: string;
    onClose?: () => void;
  }>
) => {
  const { item, filetype } = props;
  const lastPeriod = useYearsLastPeriod(item.period?.name || "");
  const [progress, setProgres] = React.useState(0);
  const [blob, setBlob] = React.useState<null | Blob>(null);
  const [status, setStatus] = React.useState<string>(t("reportGen.Generating Report").toString());
  const ctx = useAppContext();
  const { data: topElement } = useElement(item.top_element_id);
  const translatedName = getTranslatedAttribute(item, "Name", ctx.language);
  const translatedScorecardName = getTranslatedAttribute(topElement, "Name", ctx.language);

  console.log("KPIReport item ", props.item);

  return (
    <div>
      <ProgressModal
        isOpen
        onClose={() => {
          if (props.onClose) {
            props.onClose();
          }
        }}
        isComplete={!!blob}
        cancelClickHandler={props.onClose}
        completedClickHandler={() => {
          if (blob) {
            saveBlob(`${item.symbol}.${filetype}`, blob);
          }
        }}
        downloadText={t("reportGen.Download")}
        progress={progress}
        statusText={status}
      />
      <Report
        isReady={!!lastPeriod}
        template="/templates/report_en.pptx"
        onNothingToRender={() => {}}
        onProgress={(value) => {
          setProgres(value);
        }}
        onReadyToRender={async (report) => {
          setStatus(t("reportGen.Exporting slides"));
          setProgres(95);
          const blob = await createReport(
            await reportContextToRequest(report, item.symbol, filetype)
          );
          setProgres(100);
          setStatus(t("reportGen.Report ready"));
          setBlob(blob);
        }}
      >
        <Slide index={0}>
          <TextElement slideElement="title">{t("kpiReport.KPI Details")}</TextElement>
          <TextElement slideElement="subtitle">{translatedName}</TextElement>
          <TextElement slideElement="footer">
            {item.period?.name || ""}
          </TextElement>
        </Slide>
        <KPISlide item={item} translatedScorecardName={translatedScorecardName}/>
      </Report>
    </div>
  );
};

export default KPIReport;
